// extracted by css-extract-rspack-plugin
export default {"header":"CalendarPageHeader_header__EFdvL","menuWrapper":"CalendarPageHeader_menuWrapper__9kVhA"};